import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {Heading12} from '../../atoms/Text';
import {UnstyledLink} from '../../atoms/UnstyledLink/UnstyledLink';

interface TextHeaderProps {
  title: string;
  style?: React.CSSProperties;
}

export const TextHeader: React.FC<TextHeaderProps> = ({title, ...rest}) => {
  return (
    <StyledHeading data-testid="LinkHeader" {...rest}>
      {title}
    </StyledHeading>
  );
};

interface LinkHeaderProps {
  label: string;
  href: string;
  style?: React.CSSProperties;
}

export const LinkHeader: React.FC<LinkHeaderProps> = ({
  label,
  href,
  ...rest
}) => {
  return (
    <StyledLink data-testid="LinkHeader" to={href} {...rest}>
      {label}
    </StyledLink>
  );
};

const StyledHeading = styled(Heading12)`
  font-weight: ${FONT_WEIGHTS.bold};
  line-height: 1.5;
  padding-bottom: ${FONT_SIZES.px10};
  color: ${COLORS.Black};
  text-transform: uppercase;
`;

const StyledLink = styled(UnstyledLink)`
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.bold};
  line-height: 1.5;
  padding-bottom: ${FONT_SIZES.px10};
  color: ${COLORS.Black};
  text-transform: uppercase;
`;
